import React from 'react';
import { formatDistanceToNow } from 'date-fns';

export default function CameraListItem({ camera, selected, onClick, onDelete, groups }) {
  const status = camera.status;
  const isOnline = status?.online;
  const group = groups?.find(g => g.id === camera.groupId);

  return (
    <div
      onClick={onClick}
      style={{
        padding: '12px 16px',
        borderBottom: '1px solid var(--border-dim)',
        cursor: 'pointer',
        background: selected ? 'rgba(0,212,255,0.06)' : 'transparent',
        borderLeft: selected ? '2px solid var(--accent-cyan)' : '2px solid transparent',
        transition: 'all 0.15s',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
      onMouseEnter={e => { if (!selected) e.currentTarget.style.background = 'var(--bg-hover)'; }}
      onMouseLeave={e => { if (!selected) e.currentTarget.style.background = 'transparent'; }}
    >
      {/* Status dot */}
      <div style={{ flexShrink: 0 }}>
        <span className={`status-dot ${isOnline ? 'online' : status ? 'offline' : 'unknown'} ${isOnline ? 'animate-pulse' : ''}`} />
      </div>

      {/* Camera icon */}
      <div style={{
        width: '36px', height: '36px',
        background: 'var(--bg-elevated)',
        border: `1px solid ${selected ? 'var(--accent-cyan)' : 'var(--border-dim)'}`,
        borderRadius: 'var(--radius-md)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={selected ? 'var(--accent-cyan)' : 'var(--text-muted)'} strokeWidth="2">
          <circle cx="12" cy="12" r="3.5"/>
          <circle cx="12" cy="12" r="9" strokeWidth="1" opacity="0.4"/>
          <line x1="12" y1="2.5" x2="12" y2="4.5"/>
          <line x1="12" y1="19.5" x2="12" y2="21.5"/>
          <line x1="2.5" y1="12" x2="4.5" y2="12"/>
          <line x1="19.5" y1="12" x2="21.5" y2="12"/>
        </svg>
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
          <span style={{
            fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '14px',
            color: selected ? 'var(--accent-cyan)' : 'var(--text-primary)',
            letterSpacing: '0.04em', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {camera.name}
          </span>
          {group && (
            <span style={{
              fontSize: '10px', fontFamily: 'var(--font-mono)',
              padding: '1px 6px', borderRadius: '10px',
              background: `${group.color}22`, color: group.color,
              border: `1px solid ${group.color}44`,
              flexShrink: 0,
            }}>{group.name}</span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '10px', fontSize: '11px', fontFamily: 'var(--font-mono)', color: 'var(--text-muted)' }}>
          <span>{camera.ipAddress}:{camera.httpPort}</span>
          {camera.location && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>· {camera.location}</span>}
        </div>
      </div>

      {/* Right side */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px', flexShrink: 0 }}>
        {isOnline && status?.latency !== null && (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: status.latency < 100 ? 'var(--accent-green)' : status.latency < 300 ? 'var(--accent-amber)' : 'var(--accent-red)' }}>
            {status.latency}ms
          </span>
        )}
        {status?.lastSeen && (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', color: 'var(--text-muted)' }}>
            {formatDistanceToNow(new Date(status.lastSeen), { addSuffix: true })}
          </span>
        )}
        {!isOnline && status?.error && (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', color: 'var(--accent-red)' }}>
            {status.error}
          </span>
        )}
        <button
          onClick={e => { e.stopPropagation(); onDelete(); }}
          style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: '2px', marginTop: '2px' }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--accent-red)'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}
          title="Delete camera"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
